import React from 'react';
import Brochures from './Brochures';

const BrochuresHBO = () => <Brochures fixedCategory="hbo" />;

export default BrochuresHBO;
